import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditSinkNodeMappedFieldsDetailsViewModel } from 'src/app/models/audit-sink-node-mapped-fields-details-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-sink-node-mapped-fields',
  templateUrl: './audit-sink-node-mapped-fields.component.html',
  styleUrls: ['./audit-sink-node-mapped-fields.component.scss']
})
export class AuditSinkNodeMappedFieldsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public sinkNodeMappedFieldsDetails: AuditSinkNodeMappedFieldsDetailsViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.sinkNodeMappedFieldsDetails = await this._auditService.GetVSinkNodeMappedFieldsDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.sinkNodeMappedFieldsDetails, 'MerchantAuditTrail_SinkNodeMappedFields_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
